import axios from "axios";
import * as types from "../mutation-types";
import logger from "~/utilities/logger";

// state
export const state = {
  og_list: [],
  index_data: null,
  og_select: null,
  the_id: null,
};

// getters
export const getters = {
  og_list: (state) => state.og_list,
  index_data: (state) => state.index_data,
  check_list: (state) => state.og_list !== null,
  og_select: (state) => state.og_select,
  the_id: (state) => state.the_id,
};

//utils
export const getOGIndexById = (state, theId) =>
  state.og_list.findIndex((item) => item.og_id.toString() === theId.toString());
export const getOGByTheId = (state, theId) =>
  state.og_list.find((item) => item.og_id.toString() === theId.toString());

// mutations
export const mutations = {
  [types.ADD_OG](state, og)
  {
    return state.og_list.push(og);
  },
  [types.ADD_OG_FAILURE](state, error) {},

  [types.FETCH_OGS](state, { og_list, index_data })
  {
    state.index_data = index_data;
    return (state.og_list = og_list);
  },

  [types.FETCH_OGS_FAILURE](state)
  {
    logger.error("FETCH_OGS_FAILURE");
  },

  [types.FETCH_OG](state, { og_select })
  {
    return (state.og_select = og_select);
  },

  [types.FETCH_OG_FAILURE](state, { error })
  {
    logger.error("FETCH_OG_FAILURE", error);
  },

  [types.SELECT_OG](state, { og_id })
  {
    let theSelect = getOGByTheId(state, og_id);
    logger.log("store.SELECT_OG", theSelect);
    return (state.og_select = theSelect);
  },

  [types.DESELECT_OG](state)
  {
    return (state.og_select = null);
  },

  [types.DELETE_OG](state, { og_id }) {},

  [types.UPDATE_OG](state, { payload })
  {
    // state.og_select = payload.og_name;
  },

  [types.SET_OG_ID](state, { id })
  {
    return (state.the_id = id);
  },

  [types.SEARCH_OGS](state, { og_list })
  {
    return (state.og_list = og_list);
  },

  [types.SEARCH_OGS_FAILURE](state, error)
  {
    logger.error("SEARCH_OGS_FAILURE", error);
  },
};

// actions
export const actions = {
  async addOG({ commit }, data)
  {
    try
    {
      logger.log("store.addOG", "api/organization_groups", data);
      const { data } = await axios.post("api/organization_groups", data);
      if (data.status && data.status === "success")
      {
        logger.log("store.addOG rsp", data);
        return commit(types.ADD_OG, data.data);
      } else
      {
        return commit(types.DELETE_OG_FAILURE, data);
      }
    } catch (e)
    {
      logger.log("DELETE_OG_FAILURE", e);
      return commit(types.DELETE_OG_FAILURE, e);
    }
  },

  async getOGs({ commit }, options)
  {
    try
    {
      let paginate = options && options.paginate ? options.paginate : 10000;
      let extraOptions =
        options && options.extra_options ? options.extra_options : "";
      let format = options && options.format ? options.format : "minimal";
      let params =
        options && options.params
          ? options.params
          : { column: "og_is_department", condition: "=", value: 0 };

      logger.log(
        "getOGs",
        `/api/organization_groups?paginate=${paginate}&format=${format}${extraOptions}&column=${params.column
        }&condition=${encodeURIComponent(params.condition)}&value=${params.value
        }`
      );

      const { data } = await axios.get(
        `/api/organization_groups?paginate=${paginate}&format=${format}${extraOptions}&column=${params.column
        }&condition=${encodeURIComponent(params.condition)}&value=${params.value
        }`
      ); //todo
      logger.log("store.getOGs", data);
      return commit(types.FETCH_OGS, { og_list: data.data });
    } catch (e)
    {
      logger.error("store.getOGs error", e);
      return commit(types.FETCH_OGS_FAILURE);
    }
  },

  async getOG({ commit, dispatch }, payload)
  {
    if (!payload.og_id) return;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    let format = payload && payload.format ? payload.format : "minimal";
    try
    {
      const { data } = await axios.get(
        `/api/organization_groups/${payload.id}`
      );
      logger.log("store.getOGs rsp", data);
      return commit(types.FETCH_OG, { og_select: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_OG_FAILURE, { error: e });
    }
  },

  async deleteOG({ commit, dispatch }, payload)
  {
    if (!payload.og_id) return;
    let paginate = payload && payload.paginate ? payload.paginate : 10000;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    try
    {
      const { data } = await axios.delete(
        `/api/organization_groups/${payload.og_id}${extraOptions}`
      );
      logger.log("store.deleteOG rsp", data);
      return commit(types.DELETE_OG, { id: payload.og_id });
    } catch (e)
    {
      logger.error("DELETE_OG_FAILURE", e);
      // return commit(types.DELETE_OG_FAILURE, { error: e });
    }
  },

  async updateOGs({ commit, dispatch }, payload)
  {
    try
    {
      const { data } = await axios.put(
        `/api/organization_groups/${payload.og_id}`,
        payload
      );
      logger.log("store.updateOGs", data);
      return commit(types.UPDATE_OG, { payload: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_OG_FAILURE, { error: e });
    }
  },

  setOGsID({ commit, dispatch }, id)
  {
    return commit(types.SET_OG_ID, { id: id });
  },

  async searchOGs({ commit }, query)
  {
    try
    {
      const { data } = await axios.get(`/api/ ?search=${query}`);
      logger.log("store.searchOGs", data);
      return commit(types.SEARCH_OGS, { og_list: data.data.data });
    } catch (e)
    {
      logger.error("store.searchOGs error", e);
      return commit(types.SEARCH_OGS_FAILURE, e);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
